import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // eslint-disable-next-line no-console
  console.warn(
    '[vonlof] VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY is missing. ' +
      'Copy .env.example to .env.local and fill in your Supabase credentials.',
  );
}

/**
 * Browser-side Supabase client. Read-only via RLS; anon key never has write
 * access to user-data tables.
 */
export const supabase = createClient(url ?? 'http://127.0.0.1:54321', anonKey ?? 'public-anon-key', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
    storageKey: 'vonlof-frontend-auth',
  },
  db: { schema: 'public' },
  global: {
    headers: { 'x-application-name': 'vonlof-frontend' },
  },
});